module.exports = __webpack_public_path__ + "img/PlusCircle.761c2ac5.svg";